<h5 class="mb-3">
  <strong>Basic</strong>
</h5>
<div class="mb-5">
  <button nz-button (click)="createNotification('success')" class="mb-3 mr-3">Success</button>
  <button nz-button (click)="createNotification('info')" class="mb-3 mr-3">Info</button>
  <button nz-button (click)="createNotification('warning')" class="mb-3 mr-3">Warning</button>
  <button nz-button (click)="createNotification('error')" class="mb-3 mr-3">Error</button>
</div>